import React, { useState, useEffect, createContext, useContext } from 'react';

// Context für Geräteinformationen
export const DeviceContext = createContext({
  isMobile: false,
  preferredLanguage: 'de',
  userAgent: '',
  deviceDetails: {}
});

// Provider-Komponente
export const DeviceProvider = ({ children, debugMode = false }) => {
  const [deviceInfo, setDeviceInfo] = useState({
    isMobile: false,
    preferredLanguage: 'de',
    userAgent: '',
    deviceDetails: {}
  });

  useEffect(() => {
    const checkDevice = () => {
      // User-Agent für Debugging
      const userAgent = navigator.userAgent;
      
      // 1. Erkennung über User-Agent
      const isMobileByUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
      
      // 2. Alternative Erkennung über Touch-Support (typisch für mobile Geräte)
      const isTouchDevice = ('ontouchstart' in window) || 
                            (navigator.maxTouchPoints > 0) || 
                            (navigator.msMaxTouchPoints > 0);
      
      // 3. Erkennung über Bildschirmgröße
      const isMobileByScreen = window.innerWidth <= 768;
      
      // Bevorzugte Sprache ermitteln
      const language = navigator.language || navigator.userLanguage || 'de';
      
      // Gerätedetails für Debugging
      const deviceDetails = {
        userAgent,
        screenWidth: window.innerWidth,
        screenHeight: window.innerHeight,
        isMobileByUA,
        isTouchDevice,
        isMobileByScreen,
        pixelRatio: window.devicePixelRatio || 1
      };
      
      // Kombinierte Erkennung: Ein Gerät gilt als mobil, wenn der User-Agent ODER
      // die Touch-Erkennung darauf hindeuten
      const isMobile = isMobileByUA || (isTouchDevice && isMobileByScreen);
      //const isMobile = true;
      setDeviceInfo({
        isMobile,
        preferredLanguage: language,
        userAgent,
        deviceDetails
      });
      
      if (debugMode) {
        console.log('Device Detection:', deviceDetails);
        console.log('Final detection result:', isMobile ? 'Mobile' : 'Desktop');
      }
    };

    checkDevice();
    
    // Bei Größenänderung neu prüfen
    window.addEventListener('resize', checkDevice);
    
    return () => {
      window.removeEventListener('resize', checkDevice);
    };
  }, [debugMode]);

  return (
    <DeviceContext.Provider value={deviceInfo}>
      {children}
    </DeviceContext.Provider>
  );
};

// Hook für einfachen Zugriff
export const useDevice = () => useContext(DeviceContext);